'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSocial = require('react-social');

var _ = require('../');

var _PlanScorecardTakeActionShare = require('./PlanScorecardTakeActionShare.css');

var _PlanScorecardTakeActionShare2 = _interopRequireDefault(_PlanScorecardTakeActionShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardTakeActionShare = (_dec = (0, _reactCssModules2.default)(_PlanScorecardTakeActionShare2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardTakeActionShare, _Component);

  function PlanScorecardTakeActionShare(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardTakeActionShare);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardTakeActionShare.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardTakeActionShare)).call(this, props));

    _this.state = {
      description: props.description,
      url: props.url,
      petition: props.petition || false
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardTakeActionShare, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          description = _state.description,
          url = _state.url,
          petition = _state.petition;


      var resultsOrPetitionA = 'these results';
      var resultsOrPetitionB = 'employer, coworkers, or social network';
      if (petition) {
        resultsOrPetitionA = 'this petition';
        resultsOrPetitionB = 'social network';
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-share' },
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-label' },
          _react2.default.createElement(
            'h2',
            null,
            'Share ',
            resultsOrPetitionA
          ),
          _react2.default.createElement(
            'p',
            null,
            'Share ',
            resultsOrPetitionA,
            ' with your ',
            resultsOrPetitionB,
            '.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-icons' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactSocial.EmailButton,
              {
                title: 'Share via email',
                message: description,
                url: url,
                element: 'a'
              },
              _react2.default.createElement(
                'p',
                null,
                'Email'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _.Link,
              {
                to: 'https://www.facebook.com/sharer/sharer.php?u=' + url,
                title: 'Share via Facebook'
              },
              _react2.default.createElement(
                'p',
                null,
                'Facebook'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-facebook-square' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactSocial.TwitterButton,
              {
                title: 'Share via Twitter',
                message: description,
                url: url,
                element: 'a'
              },
              _react2.default.createElement(
                'p',
                null,
                'Twitter'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-twitter-square' })
              )
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardTakeActionShare;
}(_react.Component), _class2.propTypes = {
  description: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  petition: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = PlanScorecardTakeActionShare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardTakeActionShare/PlanScorecardTakeActionShare.js
// module id = 1429
// module chunks = 0